import "./Experience.css"

import { Link } from 'react-router-dom';


function Experience(prop) {
    return (
        <div className="Experience">
            <Link to={"/" + prop.experience.link}>
            {/*get thumbnail*/}
            <div className="flex-container">
            <img key={prop.experience.name + "img"} alt={prop.experience.thumbnail} src={require("./Resources/" + prop.experience.thumbnail)}/>
            <div className="experienceInfo">
                {/*Get Title*/}
                <h2>{prop.experience.name}</h2>
                {/*description*/}
                <div className="experienceDesc">
                    <p>{prop.experience.desc}</p>
                </div>
            </div>
            </div>
            </Link>
        </div>
    );
}

export default Experience